


























































































































import { Component, mixins } from 'nuxt-property-decorator'
import { filterLinkToProductReviews } from '~/assets/filters/products'
import MixinProductCard from '~/assets/mixins/product-card'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'
import ComponentProductMoreDetailsLink from '~/components/products/product-more-details-link.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentRating from '~/components/rating/rating.vue'
import ComponentProductFeature from '~/components/products/product-feature.vue'
import ComponentProductAspects from '~/components/products/product-aspects.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentProductAvailable from '~/components/products/product-available.vue'
import ComponentAddToCompareIconButton from '~/components/products/product-add-to-compare-icon-button.vue'
import ComponentProductCardImage from '~/components/products/card/product-card-image.vue'
import ComponentProductFavouriteButton from '~/components/products/card/product-favourite-button.vue'
import ComponentProductQuickViewButton from '~/components/products/card/product-quick-view-button.vue'
import ComponentProductBonus from '~/components/products/card/product-bonus.vue'

// Плитка каталога.
@Component({
  filters: {
    filterLinkToProductReviews,
  },
  components: {
    ComponentAddToCompareIconButton,
    ComponentProductAvailable,
    ComponentProductBuyButton,
    ComponentRating,
    ComponentProductAspects,
    ComponentCatalogLabels,
    ComponentProductFeature,
    ComponentProductMoreDetailsLink,
    ComponentProductDetailPricesLight,
    ComponentProductCardImage,
    ComponentProductFavouriteButton,
    ComponentProductQuickViewButton,
    ComponentProductBonus,
  },
})
export default class ComponentProductItem1 extends mixins(MixinProductCard) {
  private get classWrapper() {
    return {
      [this.$style.product]: true,
      [this.$style.disable]: !this.item.inStock,
      [this.$style.trafaret]: this.item.trafaret,
      [this.$style.shadow]: this.isProductShadow,
      ...this.classDevice(this.$style),
    }
  }

  private get classVendorCode() {
    return [this.$style.vendorCode, this.classDevice(this.$style)]
  }

  // Наличие занимает левую часть строки под названием. Если его нет, ставим
  // туда рейтинг — не оставляем строку пустой слева от артикула.
  private get showRatingInRow() {
    return this.item.reviews !== undefined && this.item.inStock === undefined
  }

  // Обычное место рейтинга — своя строка сразу под названием.
  private get showRatingStandalone() {
    return this.item.reviews !== undefined && !this.showRatingInRow
  }

  private get classTitle() {
    return [this.$style.title, this.classDevice(this.$style)]
  }

  private get classRating() {
    return [this.$style.rating, this.classDevice(this.$style)]
  }

  private get classAspects() {
    return [this.$style.aspects, this.classDevice(this.$style)]
  }

  private classFeatures = [this.$style.features, this.$style.row]

  private get classBuy() {
    return [this.$style.buy, this.classDevice(this.$style)]
  }
}
